import React from "react";
import NewOrganizationFormPresenter from "../NewOrganizationForm/NewOrganizationFormPresenter";
import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import useQueryURL from "../../../../../common/hooks/useQueryURL";

/**
 * NewOragnizationModal
 * Open a modal to create a new organization
 * @returns
 */

export default function NewOragnizationModal({
  modalId,
  isUpdate: isUpdateRaw,
  organizationIdToUpdate
}: {
  modalId?: string;
  isUpdate?: boolean;
  organizationIdToUpdate?: string;
}) {
  const isUpdate = isUpdateRaw || (!!organizationIdToUpdate);
  const { removeQueryValue} = useQueryURL();
  const MODAL_ID_PARAMS = modalId || "modal_add_org";

  const onSuccessfulSubmit = () => {
    removeQueryValue([MODAL_ID_PARAMS]);
  };
  
  return (
    <ModalDrawer
      isOpen={true}
      title={isUpdate ? "Modifier" : "Nouvelle Organisation"}
      urlParamName={MODAL_ID_PARAMS}
    >
      <NewOrganizationFormPresenter onSuccessfulSubmit={onSuccessfulSubmit} isUpdate={isUpdate} organizationIdToUpdate={organizationIdToUpdate}/>
    </ModalDrawer>
  );
}
